import { CalendarDays, TrendingUp, Users, GraduationCap } from 'lucide-react';

const BENEFITS = [
  {
    icon: CalendarDays,
    title: 'Registre seus treinos',
    description: 'Cada roll, técnica e parceiro: tudo num só lugar.',
  },
  {
    icon: TrendingUp,
    title: 'Acompanhe sua evolução',
    description: 'Horas treinadas, técnicas dominadas, reconhecimentos recebidos.',
  },
  {
    icon: Users,
    title: 'Conecte com a comunidade',
    description: 'Seus parceiros de mat e instrutores, em um feed só seu.',
  },
  {
    icon: GraduationCap,
    title: 'Aulas particulares',
    description: 'Agende com instrutores direto pelo app.',
  },
];

export const PractitionerStep3Benefits = () => (
  <div className="space-y-5">
    <div className="text-center space-y-1">
      <h3 className="text-white font-semibold text-base">Oss, agora é com você</h3>
      <p className="text-white/50 text-xs">Tudo que você precisa para crescer no jiu-jitsu.</p>
    </div>

    {/* Benefit list — vertical row per item */}
    <div className="flex flex-col gap-3">
      {BENEFITS.map(({ icon: Icon, title, description }) => (
        <div
          key={title}
          className="flex items-start gap-3 bg-[#231a1a] border border-[rgba(255,255,255,0.06)] rounded-xl p-4"
        >
          <div className="w-9 h-9 rounded-lg bg-sossiety-red/10 flex items-center justify-center flex-shrink-0 mt-0.5">
            <Icon className="w-4 h-4 text-sossiety-red" />
          </div>
          <div className="min-w-0">
            <p className="text-white text-sm font-semibold leading-tight">{title}</p>
            <p className="text-white/50 text-xs leading-snug mt-1">{description}</p>
          </div>
        </div>
      ))}
    </div>

    {/* Highlighted CTA banner */}
    <div className="rounded-xl border border-sossiety-red/30 bg-sossiety-red/5 p-4 space-y-0.5 text-center">
      <p className="text-white/60 text-xs">Comece registrando</p>
      <p className="text-white font-bold text-sm">seu primeiro treino</p>
    </div>

  </div>
);
